import { render, staticRenderFns } from "./ProjekterfassungtableDefault.vue?vue&type=template&id=447f66be"
import script from "./ProjekterfassungtableDefault.vue?vue&type=script&lang=js"
export * from "./ProjekterfassungtableDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports